const LEGISLATION_AMENDS_KEY_PREFIX = "legislation."

export function getLegislationAmendsKey(legislationId) {
    if (legislationId == null) throw new Error("getLegislationAmendsKey requires legislationId")
    return `${LEGISLATION_AMENDS_KEY_PREFIX}${legislationId}`
}

export function getLegislationIdFromAmendsKey(amendsKey = "") {
    if (typeof amendsKey !== "string" || !amendsKey.startsWith(LEGISLATION_AMENDS_KEY_PREFIX)) return null
    const id = amendsKey.slice(LEGISLATION_AMENDS_KEY_PREFIX.length)
    return id || null
}

export function isLegislationAmendsKey(amendsKey = "") {
    return Boolean(getLegislationIdFromAmendsKey(amendsKey))
}

export function normaliseLegislation(legislation = []) {
    const values = Array.isArray(legislation) ? legislation : []
    return [...new Set(values.filter(Boolean).map(String))]
}

export function getLegislationDiff(beforeLegislation = [], afterLegislation = []) {
    const before = normaliseLegislation(beforeLegislation)
    const after = normaliseLegislation(afterLegislation)

    const beforeSet = new Set(before)
    const afterSet = new Set(after)

    return {
        before,
        after,
        added: after.filter((value) => !beforeSet.has(value)),
        removed: before.filter((value) => !afterSet.has(value)),
    }
}

export { LEGISLATION_AMENDS_KEY_PREFIX }
